import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import ConnectAccount from "./Views/Withdraws/ConnectAccount";
import AlertContext from "../../Context/Alert/AlertContext";

const WithOutAccount = () => {
  const [Connect, setConnect] = useState(false);
  const { showAlert } = useContext(AlertContext);
  const navigate = useNavigate();

  const handleConnect = () => {
    setConnect(true);
  };

  const handleConnectClose = () => {
    setConnect(false);
  };

  return (
    <>
      <div
        className={`${
          Connect ? "block" : "hidden"
        } fixed top-0 left-0 z-50 w-screen h-screen flex justify-center items-center`}
      >
        <div
          className="absolute w-full h-full bg-black/50 z-10"
          onClick={handleConnectClose}
        ></div>
        <ConnectAccount setConnect={setConnect} />
      </div>
      <div className="px-6 py-6">
        <div className="flex gap-4">
          <div className="bg-white max-w-md border-1 border-[#E9E9E9] rounded-xl py-4 px-4 flex flex-col gap-3">
            <img src="../../Assets/Prop/card.png" alt="" className="w-14" />
            <h1 className="font-pop text-black font-semibold text-sm md:text-xl">
              To create and pay for an offer, connect your financial account
            </h1>
            <div className="flex flex-col gap-2">
              <button
                className="font-pop text-white text-lg bg-primarygreen rounded-3xl py-2 hover:bg-transparent border-2 border-primarygreen ease-in-out duration-300 hover:text-primarygreen"
                onClick={handleConnect}
              >
                Connect Account
              </button>
            </div>
          </div>
        </div>

        <div className="my-6">
          <h2 className="font-pop text-lg text-black font-semibold">
            Recent History
          </h2>
          <div className="flex flex-col justify-center items-center my-20">
            <div className="bg-white rounded-xl flex flex-col gap-4 justify-center items-center py-10 px-4 md:px-10">
              <p className="font-pop text-gray-400 text-center md:max-w-md">
                Before creating offers or receiving payments, you must connect a
                financial account
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WithOutAccount;
